import { IdValue } from '../../../shared/models/id-value.model';
import { ReoAccountHeldByType } from '../asset-liabilities.model';

export enum AssetType {
  BankingAssets = 1,
  OtherAssets = 4,
}

export const assetTypes: IdValue[] = [
  new IdValue(0, 'Select', 'Select'),
  new IdValue(AssetType.BankingAssets, 'Banking & Other Accounts', 'Banking & Other Accounts'),
  new IdValue(AssetType.OtherAssets, 'Other Assets', 'Other Assets'),
];

export const statementCompletedOptions: IdValue[] = [
  new IdValue(0, 'Select', 'Select'),
  new IdValue(1, 'Jointly', 'Jointly'),
  new IdValue(2, 'Not Jointly', 'Not Jointly'),
];
export const creditSourceTypes: IdValue[] = [
  new IdValue(1, 'Borrower Paid Outside Closing'),
  new IdValue(2, 'BuilderDeveloper'),
  new IdValue(3, 'Employer'),
  new IdValue(4, 'Federal Agency'),
  new IdValue(5, 'Lender'),
  new IdValue(6, 'Local Agency'),
  new IdValue(7, 'Non Parent Relative'),
  new IdValue(8, 'Other'),
  new IdValue(9, 'Parent'),
  new IdValue(10, 'Property Seller'),
  new IdValue(11, 'Real Estate Agent'),
  new IdValue(12, 'State Agency'),
  new IdValue(13, 'Unrelated Friend'),
];

export const creditTypes: IdValue[] = [
  new IdValue(1, 'Employer Assistance'),
  new IdValue(2, 'Rent Credit'),
  new IdValue(3, 'Other'),
  new IdValue(4, 'Rebate'),
  new IdValue(5, 'Relocation Funds'),
  new IdValue(6, 'Sweat Equity'),
  new IdValue(7, 'Trade Equity'),
  new IdValue(8, 'Lot Equity'),
  new IdValue(9, 'Closing Costs'),
  new IdValue(20, 'Builder'), //This is temporarily behind feature flag
];
export enum LiabilityTypesEnum {
  BankingLiabilities = 1,
  OtherLiabilities = 2,
}
export const liabilityTypes: IdValue[] = [
  new IdValue(0, 'Select'),
  new IdValue(LiabilityTypesEnum.BankingLiabilities, 'Banking Liabilities'),
  new IdValue(LiabilityTypesEnum.OtherLiabilities, 'Other Liabilities'),
];
export enum LiabilityAccountTypesEnum {
  Revolving = 1,
  Installment = 2,
  Mortgage = 3,
  HELOC = 4,
  CollectionsJudgmentsAndLiens = 5,
  LeasePayments = 6,
  Open30Day = 7,
  Taxes = 8,
  Other = 9,
  TaxLien = 10,
}
export const bankingLiabilityAccountTypes: IdValue[] = [
  new IdValue(LiabilityAccountTypesEnum.Revolving, 'Revolving'),
  new IdValue(LiabilityAccountTypesEnum.Installment, 'Installment'),
  new IdValue(LiabilityAccountTypesEnum.Mortgage, 'Mortgage'),
  new IdValue(LiabilityAccountTypesEnum.HELOC, 'HELOC'),
  new IdValue(LiabilityAccountTypesEnum.CollectionsJudgmentsAndLiens, 'Collections, Judgments, and Liens'),
  new IdValue(LiabilityAccountTypesEnum.LeasePayments, 'Lease Payments'),
  new IdValue(LiabilityAccountTypesEnum.Open30Day, 'Open 30-Day'),
  new IdValue(LiabilityAccountTypesEnum.Taxes, 'Taxes'),
  new IdValue(LiabilityAccountTypesEnum.Other, 'Other'),
  new IdValue(LiabilityAccountTypesEnum.TaxLien, 'Tax Lien'),
];
export const linkedLiabilityAccountTypes: IdValue[] = [
  new IdValue(LiabilityAccountTypesEnum.Mortgage, 'Mortgage'),
  new IdValue(LiabilityAccountTypesEnum.HELOC, 'HELOC'),
  new IdValue(LiabilityAccountTypesEnum.Other, 'Other'),
];
// looks like some account types are unused?
export const accountType: IdValue[] = [
  new IdValue(1, 'Savings'),
  new IdValue(2, 'Checking'),
  new IdValue(3, 'Cash Deposit on Sales Contract'),
  new IdValue(4, 'Gift Not Deposited'),
  new IdValue(5, 'Certificate of Deposit'),
  new IdValue(6, 'Money Market Fund'),
  new IdValue(7, 'Mutual Funds'),
  new IdValue(8, 'Stocks'),
  new IdValue(9, 'Bonds'),
  new IdValue(10, 'Secured Borrowed Funds not Deposited'),
  new IdValue(11, 'Bridge Loan Not Deposited'),
  new IdValue(12, 'Retirement Funds'),
  new IdValue(13, 'Net Worth of Business Owned'),
  new IdValue(14, 'Trust Funds'),
  new IdValue(15, 'Other Non Liquid Asset'),
  new IdValue(16, 'Other Liquid Asset'),
  new IdValue(17, 'Net Proceeds from Sale of Real Estate'),
  new IdValue(18, 'Net Equity'),
  new IdValue(19, 'Cash on Hand'),
  new IdValue(20, 'Gift of Equity'),
  new IdValue(21, 'Individual Development Account'),
  new IdValue(22, 'Life Insurance Cash Value'),
  new IdValue(23, 'Proceeds from Sale of Non-Real Estate Asset'),
  new IdValue(24, 'Secured Borrowed Funds'),
  new IdValue(25, 'Stock Options'),
  new IdValue(26, 'Unsecured Borrowed Funds'),
];

export const nonBankingOtherAccountTypesFilter = [15, 16, 17, 19, 23, 24, 26];
export const bankingAccountTypesFilter = [1, 2, 5, 6, 7, 8, 9, 11, 12, 14, 21, 22, 25];

export const heldByTypes: IdValue[] = [
  new IdValue(0, 'Select', 'Select'),
  new IdValue(1, 'Jointly', 'Jointly'),
  new IdValue(2, 'Individually', 'Individually'),
];

export const reoHeldByTypes: IdValue[] = [
  new IdValue(ReoAccountHeldByType.NotAssigned, 'Select', 'Select'),
  new IdValue(ReoAccountHeldByType.Jointly, 'Jointly', 'Jointly'),
  new IdValue(ReoAccountHeldByType.Individually, 'Individually', 'Individually'),
];

export const expenseTypes: IdValue[] = [
  new IdValue(0, 'Select'),
  new IdValue(1, 'Alimony'),
  new IdValue(2, 'Child Support'),
  new IdValue(3, 'Separate Maintenance'),
  new IdValue(4, 'Job Related Expenses'),
  new IdValue(5, 'Other Expenses'),
];

export const mortgageTypes: IdValue[] = [
  new IdValue(1, 'VA'),
  new IdValue(2, 'FHA'),
  new IdValue(3, 'Conventional'),
  new IdValue(4, 'USDA-RD'),
  new IdValue(5, 'Other'),
];

/** REO Types */
export const reoPropertyTypes: IdValue[] = [
  new IdValue(1, 'Single Family'),
  new IdValue(2, 'Condominium'),
  new IdValue(3, 'Townhouse'),
  new IdValue(4, 'Cooperative'),
  new IdValue(5, 'Two to Four unit property'),
  new IdValue(6, 'Multi Family more than four units'),
  new IdValue(7, 'Manufactured Mobile Home'),
  new IdValue(8, 'Commercial Non Residential'),
  new IdValue(9, 'Mixed user Residential'),
  new IdValue(10, 'Farm'),
  new IdValue(11, 'Home and Business Combined'),
  new IdValue(12, 'Land'),
];

export const reoPropertyStatuses: IdValue[] = [
  new IdValue(1, 'Sold'),
  new IdValue(2, 'Pending Sale'),
  new IdValue(3, 'Retained - Rental'),
  new IdValue(4, 'Retained - Non-Rental'),
];
export const statementType: IdValue[] = [new IdValue(1, 'Jointly'), new IdValue(2, 'Not Jointly')];
export enum CurrentUsageEnum {
  PrimaryResidence = 1,
  SecondHome = 2,
  Investment = 3,
}
export const currentUsage: IdValue[] = [
  new IdValue(CurrentUsageEnum.PrimaryResidence, 'Primary Residence'),
  new IdValue(CurrentUsageEnum.SecondHome, 'Second Home'),
  new IdValue(CurrentUsageEnum.Investment, 'Investment'),
];
export const intendedUsage: IdValue[] = [
  new IdValue(1, 'Primary Residence'),
  new IdValue(2, 'Second Home'),
  new IdValue(3, 'Investment'),
  new IdValue(4, 'Other'),
];
